import React from "react";

const HomeTemplate = () => {
    return (
        <div className="w-screen h-auto bg-gray-400 dark:bg-black">
        </div>
    );
};

export default HomeTemplate;